import React from 'react'
import '../App.css'
import Fade from 'react-reveal/Fade'
import Bounce from 'react-reveal/Bounce'

class About extends React.Component {
    render() {return (
    <div className="App">
    <header className="App-header">
      <a align="center" href="/SiteReact/"><Bounce>WorkSpace</Bounce></a>
    </header>
    <div class="video"><Bounce right><iframe width="560" height="315" src="https://www.youtube.com/embed/BuB7IhWZnJs" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></Bounce></div>
        <div align="center" class="borderMain border5"><h1 align="center"><Fade>About</Fade></h1>
         <Bounce left>We are biggest company for designing of officeplace<br />
        Asquardian - <a href="http://www.github.com/Asquardian">github.com/Asquardian</a></Bounce></div>
    <footer>
   <div class="App-header foot">Copyright Asquardian</div></footer>
    </div>


    
  );
    }
}

export default About;